import { CORE_PINNED_BLOCK_HEIGHTS } from "../pinned.js";
import { BITCOIN_REFERENCE_ADDRESS } from "../fixture-inputs.js";
export const BITCOIN_TEST_CONFIG = {
    balance: { address: BITCOIN_REFERENCE_ADDRESS },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.bitcoin,
        fixture: "getBlockByNumberBitcoin",
    },
};
